import { render, staticRenderFns } from "./teachingVideo.vue?vue&type=template&id=1f28d00a&scoped=true"
import script from "./teachingVideo.vue?vue&type=script&lang=js"
export * from "./teachingVideo.vue?vue&type=script&lang=js"
import style0 from "./teachingVideo.vue?vue&type=style&index=0&id=1f28d00a&prod&scoped=true&lang=less"
import style1 from "./teachingVideo.vue?vue&type=style&index=1&id=1f28d00a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f28d00a",
  null
  
)

export default component.exports